import Sticky from "../../../../../assets/vendor/sticky-js-master/index";

export default class StickyElement {
    constructor($container) {
        const $element = $container.querySelector('[data-sticky-element]');
        setTimeout(() => {
            // calculate the margin in
            if($container.clientHeight > ($element.clientHeight + 20)) {
                new Sticky('[data-sticky-element]', {});
            }
        },200)
    }
}